import { Component, Input, OnInit, Injectable } from '@angular/core';
import { NgbDate, NgbModal, NgbDateAdapter, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { HypermatrixCatalogsService } from 'src/app/services/hypermatrix-catalogs.service';
import { CommissionSalePromotionsService } from 'src/app/services/commission-sale-promotions.service';
import { VwCommissionConfiguratorService } from 'src/app/services/vw-commission-configurator.service';
import { CatalogModel } from 'src/app/model/other-catalogs-models';
import { CommissionSalePromotion } from 'src/app/model/commission-sale-promotion';
import { HMGenericCatalog } from 'src/app/model/hypermatrix-catalogs-models';
import { isNullOrUndefined } from 'util';

@Injectable()
export class CustomDateAdapter {
  fromModel(value: string): NgbDateStruct
  {
     if (!value)
      return null
     let parts=value.split('/');
     return {year:+parts[2], month:+parts[1], day:+parts[0]} as NgbDateStruct
  }
  toModel(date: NgbDateStruct): string // from internal model -> your mode
  {
    return date ? ('0'+date.day).slice(-2) + "/" + ('0'+date.month).slice(-2) + "/" + date.year : null
  }
}

@Injectable()
export class CustomDateParserFormatter {
  parse(value: string): NgbDateStruct
  {
    if (!value)
      return null
     let parts=value.split('/');
     return {year:+parts[2], month:+parts[1], day:+parts[0]} as NgbDateStruct

  }
  format(date: NgbDateStruct): string
  {
    return date ? ('0'+date.day).slice(-2) + "/" + ('0'+date.month).slice(-2) + "/" + date.year : null
  }
}

@Component({
  selector: 'app-modal-commission-sale-promotions',
  templateUrl: './modal-commission-sale-promotions.component.html',
  styleUrls: ['./modal-commission-sale-promotions.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: CustomDateAdapter},
              {provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter}]
})
export class ModalCommissionSalePromotionsComponent implements OnInit {

  @Input() salePromotion:CommissionSalePromotion;
  @Input() salePromotionOld:CommissionSalePromotion;
  @Input() logDetails:string=null;
  @Input() page:string;
  @Input() mode:string;

  // estado pagina
  public valid:boolean=false;
  public error:boolean=false;
  public viewStatus:number=1;
  public enableMinCreditAdv:boolean=false;
  public filterProducts:boolean=true;
  public formIsLocked:boolean=false;
  public minDateIni:any=null;
  public maxDateIni:any=null;
  public minDateFin:any=null;
  public maxDateFin:any=null;
  public dateIni:any=null;
  public dateFin:any=null;
  public details:string=null;
  public validateDetails:string=null;
  public userChanges:string=null;
  public title:string=null;
  public validateTitle:string=null;
  public confirmTitle:string='<i class="icon-info-circled"></i>&nbsp;&nbsp;Ha ingresado la siguiente información. Está seguro de guardar?';
  public allAfiliates:boolean=false;
  public allPaymentTerms:boolean=false;
  public allPromotions:boolean=false;
  public loadingProducts:number=0;
  public loadingAfiliates:number=0;
  public loadingPaymentTerms:number=0;
  public loadingPromotions:number=0;
  public loadingStates:number=0;
  public placement:number=0;


  // catalogos
  public employeeJobCatalog:CatalogModel[]=[];
  public businessProductCatalog:HMGenericCatalog[]=[];
  public productCatalog:any[]=[]; //=ModalCommissionSalePromotionsComponent.tube;
  public afiliateCatalog:any[]=[];
  public paymentTermCatalog:any[]=[];
  public promoCatalog:any[]=[];
  public regionsCatalog:any[]=[];
  public statesCatalog:any[]=[];
  public placementCatalog:any[]=[];

  public selectedEmployeeJobsDD:string[]=[];
  public selectedBusinessProductsDD:string[]=[];
  public selectedEmployeeJobs:any[]=[];
  public selectedBusinessProducts:any[]=[];
  public selectedProducts:any[] = [];
  public selectedAfiliates:any[]=[];
  public selectedPaymentTerms:any[]=[];
  public selectedPromos:any[]=[];
  public selectedRegions:any[]=[];
  public selectedStates:any[]=[];

  // mascaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')}
  };

  /////////////////
  constructor(
    private catEmployeeJobService:CatEmployeeJobService,
    private hypermatrixCatalogService:HypermatrixCatalogsService,
    private commissionSalePromotionsService:CommissionSalePromotionsService,
    private vwCommissionConfiguratorService:VwCommissionConfiguratorService,
    private utils:UtilitiesService,
    private modalService: NgbModal,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    console.log(">>> this.salePromotion= ", this.salePromotion);
    this.placementCatalog.push({ id:0, description:"«TODOS»"});
    this.placementCatalog.push({ id:1, description:"TRADICIONAL"});
    this.placementCatalog.push({ id:2, description:"MEDIOS DIGITALES"});
    this.placementCatalog.push({ id:3, description:"ORIGINACIÓN DIGITAL"});
    this.placementCatalog.push({ id:4, description:"UNIFIEL/DIGIFIEL"});

    let origin = this.getOrigin(this.salePromotion.digitalOrigin, this.salePromotion.unifielDigifiel, this.salePromotion.traditionalOrigin);
    if(origin === "[TODOS]"){
      this.placement = 0;
    }
    if(origin === "[TRADICIONAL]"){
      this.placement = 1;
    }
    if(origin === "[MEDIOS DIGITALES]"){
      this.placement = 2;
    }
    if(origin === "[ORIGINACIÓN DIGITAL]"){
      this.placement = 3;
    }
    if(origin === "[UNIFIEL/DIGIFIEL]"){
      this.placement = 4;
    }

    if(this.mode === "edit" && this.salePromotion.salePromotionId != null && this.salePromotion.salePromotionId > 0) {
      this.title = '<i class="icon-pencil"></i>&nbsp;&nbsp;Editar Promoción de Venta';
      this.dateIni = this.utils.convertToDDMMYYYY(this.salePromotion.promotionDateIni); //this.toNgDate(this.salePromotion.promotionDateIni);
      this.dateFin = this.utils.convertToDDMMYYYY(this.salePromotion.promotionDateFin); //this.toNgDate(this.salePromotion.promotionDateFin);

      if(this.salePromotion.saleAmountFrom === 0 && this.salePromotion.saleAmountTo === 0){
        this.salePromotion.saleAmountFrom=null;
        this.salePromotion.saleAmountTo=null;
      }

      this.getCatalogs(this.salePromotion.salePromotionId);
    }

    if(this.mode==='create') {
      this.title = '<i class="icon-plus"></i>&nbsp;&nbsp;Crear Promoción de Venta';
      this.getCatalogs(0);
    }

    if(this.mode==='detail' || this.mode==='delete' || this.mode==="toggleActive") {

      if(this.mode==='detail') this.confirmTitle = '<i class="icon-eye"></i>&nbsp;&nbsp;Detalle de la promoción de venta';
      if(this.mode==='delete') this.confirmTitle = '<i class="icon-attention"></i>&nbsp;&nbsp;Se eliminará el siguiente registro. Esta seguro de eliminar?';
      if(this.mode==='toggleActive') {
        this.toggleActive();
        this.confirmTitle = this.salePromotion.activeId ? '<i class="icon-attention"></i>&nbsp;&nbsp;Se activará el siguiente registro. Esta seguro de activar?' : '<i class="icon-attention"></i>&nbsp;&nbsp;Se desactivará el siguiente registro. Esta seguro de desactivar?';
      }

      let details = "";
      if(this.logDetails != null){
        details = this.logDetails
      } else {
        details = "<table cellpadding=\"4\"><tr class=\"border_bottom\"><td bgcolor=\"#ffffff\" valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Descripción:</font></b></td><td valign=\"top\">" + this.salePromotion.description + "</td></tr>";
        details = details + "<tr class=\"border_bottom\"><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Periodo:</font></b></td><td valign=\"top\">Del [" + this.utils.convertToDDMMYYYY(this.salePromotion.promotionDateIni) + "] al [" + this.utils.convertToDDMMYYYY(this.salePromotion.promotionDateFin) + "]</td></tr>";
        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Comisión:</font></b></td><td valign=\"top\">[" + this.salePromotion.commission + "%]</td></tr>";
        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;% Adicional al esquema base:</font></b></td><td valign=\"top\">" + (this.salePromotion.additionalSchemaBase ? '[Sí]' : '[No]') + "</td></tr>";

        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Medio Colocación:</font></b></td><td valign=\"top\">" + this.getOrigin(this.salePromotion.digitalOrigin, this.salePromotion.unifielDigifiel, this.salePromotion.traditionalOrigin) + "</td></tr>";
        //details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Originación Digital:</font></b></td><td valign=\"top\">" + (this.salePromotion.digitalOrigin ? '[Sí]' : '[No]') + "</td></tr>";
        //details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Unifiel - Digifiel:</font></b></td><td valign=\"top\">" + (this.salePromotion.unifielDigifiel ? '[Sí]' : '[No]') + "</td></tr>";

        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Monto:</font></b></td><td valign=\"top\">De [" + this.salePromotion.saleAmountFrom + "] a [" + this.salePromotion.saleAmountTo + "]</td></tr>";

        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Avance mínimo del crédito:</font></b></td><td valign=\"top\">" + (this.salePromotion.minCreditAdv ? ('[Sí] del [' + this.salePromotion.minCreditAdvPerc + '%]') : '[No]') + "</td></tr>";

        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Puestos:</font></b></td><td valign=\"top\">[" + this.salePromotion.employeeJobs + "]</td></tr>";
        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Lineas de Negocio:</font></b></td><td valign=\"top\">[" + this.salePromotion.businessProducts + "]</td></tr>";
        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Productos:</font></b></td><td valign=\"top\">[" + this.salePromotion.financingTypes + "]</td></tr>";
        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Convenios:</font></b></td><td valign=\"top\">[" + this.salePromotion.afiliates + "]</td></tr>";
        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Plazos:</font></b></td><td valign=\"top\">[" + this.salePromotion.paymentTerms + "]</td></tr>";
        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Promociones:</font></b></td><td valign=\"top\">[" + this.salePromotion.financing + "]</td></tr>";
        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Regiones:</font></b></td><td valign=\"top\">[" + this.salePromotion.regions + "]</td></tr>";
        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Estados:</font></b></td><td valign=\"top\">[" + this.salePromotion.states + "]</td></tr>";
        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Observaciones:</font></b></td><td valign=\"top\">" + this.salePromotion.observations + "</td></tr>";

        if(this.mode==='detail' || this.mode==='delete') details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Activo:</font></b></td><td valign=\"top\">" + (this.salePromotion.activeId ? '[Sí]' : '[No]') + "</td></tr>";

        details = details + "</table>";
      }

      this.details = details;
      this.viewStatus = 2;
    }

    var d = new Date();
    this.minDateIni = { year:d.getFullYear(), month:d.getMonth() + 1, day:d.getDate() + 1 };
    this.minDateFin = { year:d.getFullYear(), month:d.getMonth() + 1, day:d.getDate() + 1 };
    this.maxDateFin = { year:d.getFullYear(), month:d.getMonth() + 1, day:this.utils.getLasDay(d.getFullYear(), d.getMonth() + 1) };

    let modalContent:any = $('.modal-content');
        modalContent.draggable({
          handle: '.card-header'
          // , drag: function() {
          //   document.querySelector<HTMLElement>(".card-modal").classList.add("backdrop-modal");
          // }
        });
  }

  toNgDate(strDate) {
    if (strDate) {
      const [year, month, day] = strDate.split('-');
      const obj = { year: parseInt(year), month: parseInt(month), day:
        parseInt(day.split(' ')[0].trim()) };

      return new NgbDate(obj.year, obj.month, obj.day);
    }
  }

  //
  isValid=()=> {
    this.valid=true;
    let errors=[];

    if(this.descriptionError()) errors.push('&bull; Ingrese una descripción!');
    if(this.promotionDateIniError()) errors.push('&bull; Ingrese una fecha de inicio del periodo!');
    if(this.promotionDateFinError()) errors.push('&bull; Ingrese una fecha de fin del periodo!');
    if(this.employeeJobError()) errors.push('&bull; Seleccione un puesto!');
    if(this.businessProductError()) errors.push('&bull; Seleccione una o varias linea de negocio!');
    if(this.selectedProductsError()) errors.push('&bull; Seleccione uno o varios productos!');
    if(this.selectedAfiliatesError()) errors.push('&bull; Seleccione uno o varios convenios!');
    if(this.selectedPaymentTermsError()) errors.push('&bull; Seleccione uno o varios plazos!');
    if(this.selectedPromosError()) errors.push('&bull; Seleccione una o varias promociones!');
    if(this.selectedRegionsError()) errors.push('&bull; Seleccione una o varias regiones!');
    if(this.selectedStatesError()) errors.push('&bull; Seleccione uno o varios estados!');
    if(this.commissionError()) errors.push('&bull; Ingrese una comisión!');
    if(this.saleAmountFromError()) errors.push('&bull; Ingrese un monto inicial de venta!');
    if(this.saleAmountToError()) errors.push('&bull; Ingrese un monto final de venta!');
    if(this.saleAmountFromToError()) errors.push('&bull; El monto inicial no puede ser mayor al monto final!');
    if(this.minCreditAdvPercError()) errors.push('&bull; Ingrese un porcentaje de avance mínimo de crédito!');
    if(this.observationsError()) errors.push('&bull; Las observaciones NO pueden contener más de 550 carácteres!');

    if(errors.length>0) {
      this.valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }

    if(this.valid){

      let details = "<table cellpadding=\"4\" border=\"0\">";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Descripción:</font></b></td><td valign=\"top\">" + this.salePromotion.description + "</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Periodo:</font></b></td><td valign=\"top\">Del [" + this.utils.convertToDDMMYYYY(this.salePromotion.promotionDateIni) + "] al [" + this.utils.convertToDDMMYYYY(this.salePromotion.promotionDateFin) + "]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Comisión:</font></b></td><td valign=\"top\">[" + this.salePromotion.commission + "%]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;% Adicional al esquema base:</font></b></td><td valign=\"top\">" + (this.salePromotion.additionalSchemaBase ? '[Sí]' : '[No]') + "</td></tr>";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Medio Colocación:</font></b></td><td valign=\"top\">" + this.getOrigin(this.salePromotion.digitalOrigin, this.salePromotion.unifielDigifiel, this.salePromotion.traditionalOrigin) + "</td></tr>";
      //details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Originación Digital:</font></b></td><td valign=\"top\">" + (this.salePromotion.digitalOrigin ? '[Sí]' : '[No]') + "</td></tr>";
      //details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Unifiel - Digifiel:</font></b></td><td valign=\"top\">" + (this.salePromotion.unifielDigifiel ? '[Sí]' : '[No]') + "</td></tr>";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Monto:</font></b></td><td valign=\"top\">De [" + (!isNullOrUndefined(this.salePromotion.saleAmountFrom) ? this.salePromotion.saleAmountFrom : "0") + "] a [" + (!isNullOrUndefined(this.salePromotion.saleAmountTo) ? this.salePromotion.saleAmountTo : "0") + "]</td></tr>";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Avance mínimo del crédito:</font></b></td><td valign=\"top\">" + (this.salePromotion.minCreditAdv ? ('[Sí] del [' + this.salePromotion.minCreditAdvPerc + '%]') : '[No]') + "</td></tr>";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Puestos:</font></b></td><td valign=\"top\">[";
      this.selectedEmployeeJobs.forEach((el)=>{
        details = details + el.description + ", ";
      });
      details = details.substring(0,details.length-2) + "]</td></tr>";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Lineas de Negocio:</font></b></td><td valign=\"top\">[";
      this.selectedBusinessProducts.forEach((el)=>{
        details = details + el.description + ", ";
      });
      details = details.substring(0,details.length-2) + "]</td></tr>";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Productos:</font></b></td><td valign=\"top\">[";
      this.selectedProducts.forEach((el)=>{
        details = details + el._name + ", ";
      });
      details = details.substring(0,details.length-2) + "]</td></tr>";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Convenios:</font></b></td><td valign=\"top\">[";
      this.selectedAfiliates.forEach((el)=>{
        details = details + el._name + ", ";
      });
      details = details.substring(0,details.length-2) + "]</td></tr>";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Plazos:</font></b></td><td valign=\"top\">[";
      this.selectedPaymentTerms.forEach((el)=>{
        details = details + el._name + ", ";
      });
      details = details.substring(0,details.length-2) + "]</td></tr>";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Promociones:</font></b></td><td valign=\"top\">[";
      this.selectedPromos.forEach((el)=>{
        details = details + el._name + ", ";
      });
      details = details.substring(0,details.length-2) + "]</td></tr>";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Regiones:</font></b></td><td valign=\"top\">[";
      this.selectedRegions.forEach((el)=>{
        details = details + el._name + ", ";
      });
      details = details.substring(0,details.length-2) + "]</td></tr>";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Estados:</font></b></td><td valign=\"top\">[";
      this.selectedStates.forEach((el)=>{
        details = details + el._name + ", ";
      });
      details = details.substring(0,details.length-2) + "]</td></tr>";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Observaciones:</font></b></td><td valign=\"top\">" + this.salePromotion.observations + "</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Activo:</font></b></td><td valign=\"top\">" + (this.salePromotion.activeId ? '[Sí]' : '[No]') + "</td></tr>";
      details = details + "</table>";

      this.details = details;

      if(this.mode === "edit"){

        let userChanges = "<table cellpadding=\"4\" border=\"0\">";

        let selectedBusinessProductsOld:string[]=[];
        let selectedEmployeeJobsOld:string[]=[];
        let selectedProductsOld:string[]=[];
        let selectedAfiliatesOld:string[]=[];
        let selectedPaymentTermsOld:string[]=[];
        let selectedPromosOld:string[]=[];
        let selectedRegionsOld:string[]=[];
        let selectedStatesOld:string[]=[];
        let selectedBusinessProductsNew:string[]=[];
        let selectedEmployeeJobsNew:string[]=[];
        let selectedProductsNew:string[]=[];
        let selectedAfiliatesNew:string[]=[];
        let selectedPaymentTermsNew:string[]=[];
        let selectedPromosNew:string[]=[];
        let selectedRegionsNew:string[]=[];
        let selectedStatesNew:string[]=[];

        //ORIGINAL
        if(this.salePromotionOld.businessProducts != null && this.salePromotionOld.businessProducts.length > 0) {
          this.salePromotionOld.businessProducts.split(",").forEach(s => selectedBusinessProductsOld.push(this.utils.removeDiacriticsAndSpaces(s, true)));
        }

        if(this.salePromotionOld.employeeJobs != null && this.salePromotionOld.employeeJobs.length > 0) {
          this.salePromotionOld.employeeJobs.split(",").forEach(s => selectedEmployeeJobsOld.push(this.utils.removeDiacriticsAndSpaces(s, true)));
        }

        if(this.salePromotionOld.financingTypes != null && this.salePromotionOld.financingTypes.length > 0) {
          this.salePromotionOld.financingTypes.split(",").forEach(s => selectedProductsOld.push(this.utils.removeDiacriticsAndSpaces(s, true)));
        }

        if(this.salePromotionOld.afiliates != null && this.salePromotionOld.afiliates.length > 0) {
          this.salePromotionOld.afiliates.split(",").forEach(s => selectedAfiliatesOld.push(this.utils.removeDiacriticsAndSpaces(s, true)));
        }

        if(this.salePromotionOld.paymentTerms != null && this.salePromotionOld.paymentTerms.length > 0) {
          this.salePromotionOld.paymentTerms.split(",").forEach(s => selectedPaymentTermsOld.push(this.utils.removeDiacriticsAndSpaces(s, true)));
        }

        if(this.salePromotionOld.financing != null && this.salePromotionOld.financing.length > 0) {
          this.salePromotionOld.financing.split(",").forEach(s => selectedPromosOld.push(this.utils.removeDiacriticsAndSpaces(s, true)));
        }

        if(this.salePromotionOld.regions != null && this.salePromotionOld.regions.length > 0) {
          this.salePromotionOld.regions.split(",").forEach(s => selectedRegionsOld.push(this.utils.removeDiacriticsAndSpaces(s, true)));
        }

        if(this.salePromotionOld.states != null && this.salePromotionOld.states.length > 0) {
          this.salePromotionOld.states.split(",").map(s => selectedStatesOld.push(this.utils.removeDiacriticsAndSpaces(s, true)));
        }

        //NUEVO
        this.selectedBusinessProducts.forEach((el)=> selectedBusinessProductsNew.push(this.utils.removeDiacriticsAndSpaces(el.description, true)));
        this.selectedEmployeeJobs.forEach((el)=>selectedEmployeeJobsNew.push(this.utils.removeDiacriticsAndSpaces(el.description, true)));
        this.selectedProducts.forEach((el)=>selectedProductsNew.push(this.utils.removeDiacriticsAndSpaces(el._name, true)));
        this.selectedAfiliates.forEach((el)=>selectedAfiliatesNew.push(this.utils.removeDiacriticsAndSpaces(el._name, true)));
        this.selectedPaymentTerms.forEach((el)=>selectedPaymentTermsNew.push(this.utils.removeDiacriticsAndSpaces(el._name, true)));
        this.selectedPromos.forEach((el)=>selectedPromosNew.push(this.utils.removeDiacriticsAndSpaces(el._name, true)));
        this.selectedRegions.forEach((el)=>selectedRegionsNew.push(this.utils.removeDiacriticsAndSpaces(el._name, true)));
        this.selectedStates.forEach((el)=>selectedStatesNew.push(this.utils.removeDiacriticsAndSpaces(el._name, true)));

        selectedBusinessProductsNew = selectedBusinessProductsNew.filter(r=>!selectedBusinessProductsOld.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedEmployeeJobsNew = selectedEmployeeJobsNew.filter(r=>!selectedEmployeeJobsOld.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedProductsNew = selectedProductsNew.filter(r=>!selectedProductsOld.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedAfiliatesNew = selectedAfiliatesNew.filter(r=>!selectedAfiliatesOld.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedPaymentTermsNew = selectedPaymentTermsNew.filter(r=>!selectedPaymentTermsOld.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedPromosNew = selectedPromosNew.filter(r=>!selectedPromosOld.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedRegionsNew = selectedRegionsNew.filter(r=>!selectedRegionsOld.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedStatesNew = selectedStatesNew.filter(r=>!selectedStatesOld.includes(this.utils.removeDiacriticsAndSpaces(r, true)));

        let selectedBusinessProductsDescr:string[] = this.selectedBusinessProducts.map(function(row) {
          return this.utils.removeDiacriticsAndSpaces(row.description, true);
        },this);

        let selectedEmployeeJobsDescr:string[] = this.selectedEmployeeJobs.map(function(row) {
          return this.utils.removeDiacriticsAndSpaces(row.description, true);
        },this);

        let selectedProductsDescr:string[] = this.selectedProducts.map(function(row) {
          return this.utils.removeDiacriticsAndSpaces(row._name, true);
        },this);

        let selectedAfiliatesDescr:string[] = this.selectedAfiliates.map(function(row) {
          return this.utils.removeDiacriticsAndSpaces(row._name, true);
        },this);

        let selectedPaymentTermsDescr:string[] = this.selectedPaymentTerms.map(function(row) {
          return this.utils.removeDiacriticsAndSpaces(row._name, true);
        },this);

        let selectedPromosDescr:string[] = this.selectedPromos.map(function(row) {
          return this.utils.removeDiacriticsAndSpaces(row._name, true);
        },this);

        let selectedRegionsDescr:string[] = this.selectedRegions.map(function(row) {
          return this.utils.removeDiacriticsAndSpaces(row._name, true);
        },this);

        let selectedStatesDescr:string[] = this.selectedStates.map(function(row) {
          return this.utils.removeDiacriticsAndSpaces(row._name, true);
        },this);

        selectedBusinessProductsOld = selectedBusinessProductsOld.filter(r=>!selectedBusinessProductsDescr.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedEmployeeJobsOld = selectedEmployeeJobsOld.filter(r=>!selectedEmployeeJobsDescr.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedProductsOld = selectedProductsOld.filter(r=>!selectedProductsDescr.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedAfiliatesOld = selectedAfiliatesOld.filter(r=>!selectedAfiliatesDescr.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedPaymentTermsOld = selectedPaymentTermsOld.filter(r=>!selectedPaymentTermsDescr.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedPromosOld = selectedPromosOld.filter(r=>!selectedPromosDescr.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedRegionsOld = selectedRegionsOld.filter(r=>!selectedRegionsDescr.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedStatesOld = selectedStatesOld.filter(r=>!selectedStatesDescr.includes(this.utils.removeDiacriticsAndSpaces(r, true)));

        if(!(this.utils.removeDiacriticsAndSpaces(this.salePromotion.description, true) === this.utils.removeDiacriticsAndSpaces(this.salePromotionOld.description, true)))
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Descripción:</font></b></td><td valign=\"top\">" + this.salePromotion.description + "</td></tr>";

        if(!(this.salePromotion.promotionDateIni === this.salePromotionOld.promotionDateIni) || !(this.salePromotion.promotionDateFin === this.salePromotionOld.promotionDateFin))
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Periodo:</font></b></td><td valign=\"top\">Del [" + this.utils.convertToDDMMYYYY(this.salePromotion.promotionDateIni) + "] al [" + this.utils.convertToDDMMYYYY(this.salePromotion.promotionDateFin) + "]</td></tr>";

        if(!(this.salePromotion.commission === this.salePromotionOld.commission))
           userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Comisión:</font></b></td><td valign=\"top\">[" + this.salePromotion.commission + "%]</td></tr>";

        if(!(this.salePromotion.additionalSchemaBase === this.salePromotionOld.additionalSchemaBase))
           userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;% Adicional al esquema base:</font></b></td><td valign=\"top\">" + (this.salePromotion.additionalSchemaBase ? '[Sí]' : '[No]') + "</td></tr>";

        if(!(this.getOrigin(this.salePromotion.digitalOrigin, this.salePromotion.unifielDigifiel, this.salePromotion.traditionalOrigin) === this.getOrigin(this.salePromotionOld.digitalOrigin, this.salePromotionOld.unifielDigifiel, this.salePromotionOld.traditionalOrigin)))
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Medio Colocación:</font></b></td><td valign=\"top\">" + this.getOrigin(this.salePromotion.digitalOrigin, this.salePromotion.unifielDigifiel, this.salePromotion.traditionalOrigin) + "</td></tr>";

        //if(!(this.salePromotion.digitalOrigin === this.salePromotionOld.digitalOrigin))
        //   userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Originación Digital:</font></b></td><td valign=\"top\">" + (this.salePromotion.digitalOrigin ? '[Sí]' : '[No]') + "</td></tr>";
        //if(!(this.salePromotion.unifielDigifiel === this.salePromotionOld.unifielDigifiel))
        //   userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Unifiel - Digifiel:</font></b></td><td valign=\"top\">" + (this.salePromotion.unifielDigifiel ? '[Sí]' : '[No]') + "</td></tr>";

        if(isNullOrUndefined(this.salePromotionOld.saleAmountFrom)) this.salePromotionOld.saleAmountFrom = 0;
        if(isNullOrUndefined(this.salePromotionOld.saleAmountTo)) this.salePromotionOld.saleAmountTo = 0;
        if(isNullOrUndefined(this.salePromotion.saleAmountFrom)) this.salePromotion.saleAmountFrom = 0;
        if(isNullOrUndefined(this.salePromotion.saleAmountTo)) this.salePromotion.saleAmountTo = 0;
        if(!(this.salePromotion.saleAmountFrom === this.salePromotionOld.saleAmountFrom) || !(this.salePromotion.saleAmountTo === this.salePromotionOld.saleAmountTo))
           userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Monto:</font></b></td><td valign=\"top\">De [" + this.salePromotion.saleAmountFrom + "] a [" + this.salePromotion.saleAmountTo + "]</td></tr>";

        if(isNullOrUndefined(this.salePromotion.minCreditAdvPerc)) this.salePromotion.minCreditAdvPerc = 0;
        if(!(this.salePromotion.minCreditAdvPerc === this.salePromotionOld.minCreditAdvPerc))
           userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Avance mínimo del crédito:</font></b></td><td valign=\"top\">" + (this.salePromotion.minCreditAdv ? "[Sí] del [" + this.salePromotion.minCreditAdvPerc + "%]" : "[No]") + "</td></tr>";

        if(selectedEmployeeJobsNew.length > 0){
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Puestos Agregados:</font></b></td><td valign=\"top\">[";
          selectedEmployeeJobsNew.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0, userChanges.length-2) + "]</td></tr>";
        }

        if(selectedEmployeeJobsOld.length > 0){
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Puestos Descartados:</font></b></td><td valign=\"top\">[";
          selectedEmployeeJobsOld.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0, userChanges.length-2) + "]</td></tr>";
        }

        if(selectedBusinessProductsNew.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Lineas de Negocio Agregadas:</font></b></td><td valign=\"top\">[";
          selectedBusinessProductsNew.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0, userChanges.length-2) + "]</td></tr>";
        }

        if(selectedBusinessProductsOld.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Lineas de Negocio Descartadas:</font></b></td><td valign=\"top\">[";
          selectedBusinessProductsOld.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0, userChanges.length-2) + "]</td></tr>";
        }

        if(selectedProductsNew.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Productos Agregados:</font></b></td><td valign=\"top\">[";
          selectedProductsNew.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedProductsOld.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Productos Descartados:</font></b></td><td valign=\"top\">[";
          selectedProductsOld.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedAfiliatesNew.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Convenios Agregados:</font></b></td><td valign=\"top\">[";
          selectedAfiliatesNew.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedAfiliatesOld.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Convenios Descartados:</font></b></td><td valign=\"top\">[";
          selectedAfiliatesOld.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedPaymentTermsNew.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Plazos Agregados:</font></b></td><td valign=\"top\">[";
          selectedPaymentTermsNew.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedPaymentTermsOld.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Plazos Descartados:</font></b></td><td valign=\"top\">[";
          selectedPaymentTermsOld.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedPromosNew.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Promociones Agregadas:</font></b></td><td valign=\"top\">[";
          selectedPromosNew.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedPromosOld.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Promociones Descartadas:</font></b></td><td valign=\"top\">[";
          selectedPromosOld.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedRegionsNew.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Regiones Agregadas:</font></b></td><td valign=\"top\">[";
          selectedRegionsNew.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedRegionsOld.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Regiones Descartadas:</font></b></td><td valign=\"top\">[";
          selectedRegionsOld.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedStatesNew.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Estados Agregados:</font></b></td><td valign=\"top\">[";
          selectedStatesNew.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedStatesOld.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Estados Descartados:</font></b></td><td valign=\"top\">[";
          selectedStatesOld.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(!(this.utils.removeDiacriticsAndSpaces(this.salePromotion.observations, true) === this.utils.removeDiacriticsAndSpaces(this.salePromotionOld.observations, true)))
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Observaciones:</font></b></td><td valign=\"top\">" + this.salePromotion.observations + "</td></tr>";

        this.userChanges = userChanges + "</table>";
        //console.log(">> this.userChanges=", this.userChanges);
      }

      this.viewStatus = 2;
    }else{
      this.viewStatus = 1;
      this.details = null;
      this.userChanges = null;
    }
  }

  closeConfirm=()=> {
    if(this.mode==="delete" || this.mode==="toggleActive" || this.mode==="detail"){
      this.modalService.dismissAll();
    }else{
      this.viewStatus = 1;
      this.details = null;
      this.validateDetails = null;
      this.userChanges = null;
    }
  }

  save=()=> {
    if(this.error){
      this.modalService.dismissAll('success');
      return;
    }

    if(this.mode==="delete" || this.mode==="toggleActive"){

      delete this.salePromotion.employeeJobs;
      delete this.salePromotion.businessProducts;
      delete this.salePromotion.financingTypes;
      delete this.salePromotion.afiliates;
      delete this.salePromotion.paymentTerms;
      delete this.salePromotion.financing;
      delete this.salePromotion.createDate;
      delete this.salePromotion.modifDate;
      delete this.salePromotion.regions;
      delete this.salePromotion.states;

      this.salePromotion.modifUserId=Number(localStorage.getItem('com_token'));

      let request:any = {
        commissionSalePromotion: this.salePromotion,
        "listEmployeeJobs": [],
        "listBusinessProducts": [],
        "listFinancingTypes": [],
        "listPaymentTerms": [],
        "listAfiliates": [],
        "listFinancing": [],
        "listRegions": [],
        "listStates": [],
        "details": this.details
      };

      if(this.mode==="delete"){
        request.userChanges = "Se ha eliminado la comisión de venta!";
        this.commissionSalePromotionsService.delete(request)
        .subscribe((resp:any)=> {
          if(resp && resp.codeHttpStatus===200) {
            this.modalService.dismissAll('success');
            this.toastr.success('El registro se ha eliminado correctamente!');
          }
          if(resp && resp.codeHttpStatus===409) {
            this.confirmTitle='<i class="icon-attention"></i>&nbsp;&nbsp; Error al eliminar!';
            this.details = '<h6>No se pude eliminar el registro seleccionado debido a reglas de negocio!</h6>';
            this.error = true;
          }
        });
      }

      if(this.mode==="toggleActive"){
        let status = this.salePromotion.activeId ? 'activado' : 'desactivado';
        request.userChanges = "Se ha " + status + " la comisión de venta!";
        this.commissionSalePromotionsService.updateStatus(request)
        .subscribe((resp:any)=> {
          if(resp && resp.codeHttpStatus===200) {
            this.modalService.dismissAll('success');
            this.toastr.success('El registro se ha ' + status + ' correctamente!');
          }
        });
      }
    }

    if(this.mode==="create" || this.mode==="edit"){
      if(this.valid && this.details != null) {
        this.viewStatus=0;
        let request:any = {
          commissionSalePromotion: {
            "description": this.salePromotion.description,
            "promotionDateIni": this.salePromotion.promotionDateIni,
            "promotionDateFin": this.salePromotion.promotionDateFin,
            "saleAmountFrom": !isNullOrUndefined(this.salePromotion.saleAmountFrom) ? this.salePromotion.saleAmountFrom : 0,
            "saleAmountTo": !isNullOrUndefined(this.salePromotion.saleAmountTo) ? this.salePromotion.saleAmountTo : 0,
            "commission": this.salePromotion.commission,
            "additionalSchemaBase": this.salePromotion.additionalSchemaBase,
            "digitalOrigin": this.salePromotion.digitalOrigin,
            "unifielDigifiel": this.salePromotion.unifielDigifiel,
            "traditionalOrigin": this.salePromotion.traditionalOrigin,
            "minCreditAdv": this.salePromotion.minCreditAdv,
            "minCreditAdvPerc": !isNullOrUndefined(this.salePromotion.minCreditAdvPerc) ? this.salePromotion.minCreditAdvPerc : 0,
            "observations": this.salePromotion.observations,
            "onlyRefi": this.enableMinCreditAdv
          },
          "listEmployeeJobs": this.selectedEmployeeJobs.map(function(row) {
            return row.id;
          }),
          "listBusinessProducts": this.selectedBusinessProducts.map(function(row) {
            return row.id;
          }),
          "listFinancingTypes": this.selectedProducts.map(function(row) {
            return row._id;
          }),
          "listPaymentTerms": this.selectedPaymentTerms.map(function(row) {
            return row._id;
          }),
          "listAfiliates": this.selectedAfiliates.map(function(row) {
            return row._id;
          }),
          "listFinancing": this.selectedPromos.map(function(row) {
            return row._id;
          }),
          "listRegions": this.selectedRegions.map(function(row) {
            return row._id;
          }),
          "listStates": this.selectedStates.map(function(row) {
            return row._id;
          }),
          "details": this.details
        };

        if(this.mode === 'edit' && this.salePromotion.salePromotionId != null && this.salePromotion.salePromotionId > 0){
          request.commissionSalePromotion.salePromotionId = this.salePromotion.salePromotionId;
          request.commissionSalePromotion.activeId = this.salePromotion.activeId;
          request.commissionSalePromotion.createUserId = this.salePromotion.createUserId;
          request.commissionSalePromotion.modifUserId = Number(localStorage.getItem('com_token'));
          request.userChanges = this.userChanges;
        }else{
          request.commissionSalePromotion.createUserId = this.salePromotion.createUserId;
          request.userChanges = this.details;
        }

        this.validateRequest(request);
      }
    }
  }

  validateRequest=(request:any)=>{
    console.log(">>> validateRequest >> request=", request);
    this.commissionSalePromotionsService.validate(request)
      .pipe(
        tap((resp:any)=> {
          console.log(">>> validateRequest >> response=", resp);
          if(resp.data2 != null){
            if(Number(resp.data2) > 0){
              this.viewStatus = 3;
              if(resp.data2 === 1){
                this.validateTitle = "&nbsp;&nbsp;No se pueden editar la promoción de venta!";
                this.validateDetails = "La promoción de venta ya ha sido aplicada en comisiones diarias!<br/><br/>";
              }
              if(resp.data2 === 2){
                this.validateTitle = "&nbsp;&nbsp;Existen promociones de venta con la misma descripción!";
                this.validateDetails = "Las siguiente promoción de venta tienen la misma descripción:<br/><br/>";
                resp.data.forEach((s)=>{
                  this.validateDetails = this.validateDetails + "&bull;&nbsp;&nbsp;" + s + "<br/>";
                },this);
              }
              if(resp.data2 === 3){
                this.validateTitle = "&nbsp;&nbsp;Existen promociones de venta activas y vigentes que contemplan esta información!";
                this.validateDetails = "Favor de verificar las siguientes promociones de venta:<br/><br/>";
                resp.data.forEach((s)=>{
                  this.validateDetails = this.validateDetails + "&bull;&nbsp;&nbsp;" + s + "<br/>";
                },this);
              }
            }else{
              //console.log(">> SAVE");
              this.saveRequest(request);
            }
          }else{
            this.toastr.error('Ocurrió un error al procesar la solicitud...');
            this.viewStatus=1;
          }
        }),
        catchError(error=> {
          return of(this.toastr.error('Ocurrió un error al procesar la solicitud...'));
        })
      )
      .subscribe();
  }

  saveRequest=(request:any)=>{
    this.commissionSalePromotionsService.save(request)
      .pipe(
        tap((resp:any)=> {
          console.log(">>> saveRequest >> response=", resp);
          if(resp.data != null && resp.codeHttpStatus === 200){
            request.commissionSalePromotion.salePromotionId = resp.data.salePromotionId;
            //this.saveConfigsAsync(request);
            this.modalService.dismissAll('success');
            this.toastr.success('La promoción de venta se guardó con éxito!');
          }else{
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar la promoción de venta...'));
          }
        }),
        catchError(error=> {
          this.modalService.dismissAll('failure');
          return of(this.toastr.error('Ocurrió un error al intentar guardar la promoción de venta...'));
        })
      )
      .subscribe();
  }

  saveConfigsAsync=(request:any)=>{
    console.log(">>> saveConfigsAsync >> request=", request);
    this.commissionSalePromotionsService.saveConfigsAsync(request)
      .pipe(
        tap((resp:any)=> {
          console.log(">>> saveConfigsAsync >> response=", resp);
          if(resp.data != null && (resp.codeHttpStatus === 200)){
            this.modalService.dismissAll('success');
            this.toastr.success('La promoción de venta se guardó con éxito!');
          }else{
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar la promoción de venta...'));
          }
        }),
        catchError(error=> {
          console.log("-- error ini --------------------------------------------------------------------------------")
          console.log(error);
          console.log("-- error fin --------------------------------------------------------------------------------")
          this.modalService.dismissAll('failure');
          return of(this.toastr.error('Ocurrió un error al intentar guardar la promoción de venta...'));
        })
      )
      .subscribe();
  }


  close=()=> {
    this.modalService.dismissAll();
  }

  // HELPERS
  descriptionError=()=> (this.salePromotion.description!=="" && !this.salePromotion.description) || this.salePromotion.description==="";
  promotionDateIniError=()=> this.salePromotion.promotionDateIni!=="" && !this.salePromotion.promotionDateIni;
  promotionDateFinError=()=> this.salePromotion.promotionDateFin!=="" && !this.salePromotion.promotionDateFin;
  employeeJobError=()=> !(this.selectedEmployeeJobs != null && this.selectedEmployeeJobs.length > 0);
  businessProductError=()=> !(this.selectedBusinessProducts != null && this.selectedBusinessProducts.length > 0);
  selectedProductsError=()=> !(this.selectedProducts != null && this.selectedProducts.length > 0);
  selectedAfiliatesError=()=> !(this.selectedAfiliates != null && this.selectedAfiliates.length > 0);
  selectedPaymentTermsError=()=> !(this.selectedPaymentTerms != null && this.selectedPaymentTerms.length > 0);
  selectedPromosError=()=> !(this.selectedPromos != null && this.selectedPromos.length > 0);
  selectedRegionsError=()=> !(this.selectedRegions != null && this.selectedRegions.length > 0);
  selectedStatesError=()=> !(this.selectedStates != null && this.selectedStates.length > 0);
  commissionError=()=> this.salePromotion.commission!==0 && !this.salePromotion.commission;
  saleAmountFromError=()=> isNullOrUndefined(this.salePromotion.saleAmountFrom) && this.salePromotion.saleAmountTo != null;
  saleAmountToError=()=> isNullOrUndefined(this.salePromotion.saleAmountTo) && this.salePromotion.saleAmountFrom != null;
  saleAmountFromToError=()=> (this.salePromotion.saleAmountFrom != null && this.salePromotion.saleAmountTo != null) && (this.salePromotion.saleAmountFrom >= this.salePromotion.saleAmountTo);
  minCreditAdvPercError=()=> isNullOrUndefined(this.salePromotion.minCreditAdvPerc) && this.salePromotion.minCreditAdv;
  compare(a:any, b:any) {
		const arr = [];
		return arr.indexOf(a._id) - arr.indexOf(b._id);
	}
  updateCommission=e=> this.salePromotion.commission=!e || e.trim()===''?null:Number(e);
  updateSaleAmountFrom=e=> this.salePromotion.saleAmountFrom=!e || e.trim()===''?null:Number(e);
  updateSaleAmountTo=e=> this.salePromotion.saleAmountTo=!e || e.trim()===''?null:Number(e);
  updateMinCreditAdvPerc=e=> this.salePromotion.minCreditAdvPerc=!e || e.trim()===''?null:Number(e);
  toggleActive=()=> this.salePromotion.activeId=!this.salePromotion.activeId;
  toggleAdditionalSchema=()=> this.salePromotion.additionalSchemaBase = !this.salePromotion.additionalSchemaBase;
  toggleDigitalOrigin=()=> this.salePromotion.digitalOrigin = !this.salePromotion.digitalOrigin;
  toggleUnifielDigifiel=()=> this.salePromotion.unifielDigifiel = !this.salePromotion.unifielDigifiel;
  toggleMinCreditAdv=()=> this.salePromotion.minCreditAdv = !this.salePromotion.minCreditAdv;
  observationsError=()=> this.salePromotion.observations!==null && this.salePromotion.observations.length > 550;

  // EVENTS
  onSelectDateIni(evt:any){
    let d = new Date(evt.year,evt.month-1,evt.day);
    this.minDateFin = { year:d.getFullYear(), month:d.getMonth() + 1, day:d.getDate() };
    this.maxDateFin = { year:d.getFullYear(), month:d.getMonth() + 1, day:this.utils.getLasDay(d.getFullYear(), d.getMonth() + 1) };

    let month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    this.salePromotion.promotionDateIni = [year, month, day].join('-');
    //console.log(">> this.salePromotion.promotionDateIni= " + this.salePromotion.promotionDateIni);
  }
  onSelectDateFin(evt:any){
    let d = new Date(evt.year,evt.month-1,evt.day);
    let month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    this.salePromotion.promotionDateFin = [year, month, day].join('-');
    //console.log(">> this.salePromotion.promotionDateIni= " + this.salePromotion.promotionDateFin);
  }
  employeeJobChange=e=> {
    //console.log(">>  this.selectedEmployeeJobsDD= ",  this.selectedEmployeeJobsDD);
    if(e.length > 0){
      this.selectedEmployeeJobs=e;
      //console.log(">> this.selectedEmployeeJobs= ", this.selectedEmployeeJobs);
    } else {
      this.selectedEmployeeJobs=[];
    }
  };
  businessProductChange=e=>{

    this.selectedProducts=[];
    this.selectedAfiliates=[];
    this.selectedPaymentTerms=[];

    this.productCatalog=[];
    this.afiliateCatalog=[];
    this.paymentTermCatalog=[];

    if(e.length > 0){
      this.selectedBusinessProducts=e;

      //Cargar PRODUCTOS X LINEA DE NEGOCIO seleccionada
      if(this.selectedBusinessProducts != null && this.selectedBusinessProducts.length>0){
        this.loadingProducts = 1;
        let businessProductId:number[]=[];
        this.selectedBusinessProducts.forEach((el)=>{
          businessProductId.push(el.id);
        });
        this.vwCommissionConfiguratorService.getFinancingTypesByBusinessProduct(businessProductId)
        .subscribe((resp:any)=> {
          if(resp && resp.codeHttpStatus===200) {
            this.productCatalog = resp.data.map(function(row) {
              return { _id : row.id, _name : row.description }
            });
            this.loadingProducts = 0;
          }
        });
      }
    }else{
      this.selectedBusinessProducts=[];
    }
  };
  productsChange=e=> {
    console.log(">> this.selectedProducts= ", this.selectedProducts);

    this.selectedAfiliates=[];
    this.selectedPaymentTerms=[];

    this.afiliateCatalog=[];
    this.paymentTermCatalog=[];

    //let refis:number[]=[2,8,5,13,37,35,6,3];
    this.enableMinCreditAdv = false;
    this.salePromotion.minCreditAdv = false;
    this.salePromotion.minCreditAdvPerc=null;
    // if(this.selectedProducts.every(item => refis.includes(item._id))){
    //   this.enableMinCreditAdv = true;
    // }
    if(this.selectedProducts.every(item => item._name.substring(0,4).toUpperCase() === 'REFI')){
      this.enableMinCreditAdv = true;
    }

    //Cargar CONVENIOS X PRODUCTO seleccionado
    if(this.selectedProducts != null && this.selectedProducts.length > 0){
      this.loadingAfiliates = 1;
      let financingTypeId:number[]=[];
      this.selectedProducts.forEach((el)=>{
        financingTypeId.push(el._id);
      });
      this.vwCommissionConfiguratorService.getAfiliatesByFinancingType(financingTypeId)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          this.afiliateCatalog=resp.data.map(function(row) {
            return { _id : row.id, _name : row.description }
          });
          this.loadingAfiliates = 0;
        }
      });
    }
  }
  productChange=e=> {
    //console.log(">> e= ", e);
    //console.log(">> selectChange > new List= ", this.selectedProducts);
  };
  afiliatesChange=e=> {
      this.selectedPaymentTerms=[];
      this.paymentTermCatalog=[];

      //Cargar PLAZOS X CONVENIO seleccionado
      if(this.selectedAfiliates != null && this.selectedAfiliates.length > 0){
        this.loadingPaymentTerms = 1;

        let afiliateId:number[]=[];
        this.allAfiliates = false;

        this.selectedAfiliates.forEach((el)=>{
          if(el._id === 0) this.allAfiliates = true
        },this);

        //Agregar TODOS los CONVENIOS
        if(this.allAfiliates){
          this.selectedAfiliates = []; //this.selectedAfiliates.filter(item => item._id === 0);
          this.selectedAfiliates.push({ _id:0, _name:"«TODOS»" });
          this.afiliateCatalog.forEach((el)=>{
            if(el._id > 0) {
              this.selectedAfiliates.push(el);
            }
          },this);
        }

        this.selectedAfiliates.forEach((el)=>{
          if(el._id > 0) afiliateId.push(el._id);
        });

        this.vwCommissionConfiguratorService.getPaymentTermsByAfiliate(afiliateId)
        .subscribe((resp:any)=> {
          if(resp && resp.codeHttpStatus===200) {
            this.paymentTermCatalog=resp.data.map(function(row) {
              if(row.id!==21 && row.id!==22 && row.id!==23) return { _id : row.id, _name : row.description }
            });
            this.loadingPaymentTerms = 0;
          }
        });
      }
  }
  paymentTermsChange=e=> {
    //console.log(">>> paymentTermsChange >> e= ", e);
    this.selectedPromos=[];
    this.promoCatalog=[];

    this.allPaymentTerms = false;
    this.selectedPaymentTerms.forEach((el)=>{
      if(el._id === 0) this.allPaymentTerms = true;
    },this);

    //Agregar TODOS los PLAZOS
    if(this.allPaymentTerms){
      this.selectedPaymentTerms = [];
      this.selectedPaymentTerms.push({ _id:0, _name:"«TODOS»" }); //this.selectedPaymentTerms.filter(item => item._id === 0);
      this.paymentTermCatalog.forEach((el)=>{
        if(el._id > 0) {
          this.selectedPaymentTerms.push(el);
        }
      },this);
    }

    this.loadPromotions(null);   //Obtener las PROMOCIONES X NEGOCIO, TIPO FONDEO, PRODUCTO, CONVENIO Y PLAZO seleccionado
  }
  promotionsChange=e=> {
    //console.log(">>> destinationPromotionsChange >> e= ", e);
    //console.log(">>> destinationPromotionsChange >> this.selectedPromos= ", this.selectedPromos);
    this.allPromotions = false;
    this.selectedPromos.forEach((el)=>{
      if(el._id === "ALL") this.allPromotions = true;
    },this);

    //Agregar TODOS las PROMOCIONES
    if(this.allPromotions){
      this.selectedPromos = [];
      this.selectedPromos.push({ _id:'ALL', _name:"«TODOS»" }); //this.selectedPromos.filter(item => item._id === "ALL");
      this.promoCatalog.forEach((el)=>{
        if(el._id.length > 3) {
          this.selectedPromos.push(el);
        }
      },this);
    }
  };
  regionsChange=e=> {
    this.loadingStates = 1;
    //console.log(">> this.selectedRegions= ", e);
    this.selectedStates=[];
    this.statesCatalog=[];

    let regions:number[]=[];
    this.selectedRegions.forEach((el)=>{
      if(el._id > 0) regions.push(el._id);
    });

    this.commissionSalePromotionsService.getListCatStatesByRegion(regions)
    .subscribe((resp:any)=> {
      if(resp && resp.codeHttpStatus===200) {
        this.statesCatalog = resp.data.map(function(row){
          return { _id : row.stateGoalId, _name : row.stateDescription }
        });
        this.loadingStates = 0;
      }
    });
  };
  statesChange=e=> {
    //console.log(">> this.selectedStates= ", e);
  };
  placementChange=e=> {
    console.log(">> placement=", this.placement);
    //TODOS
    if(this.placement === 0){
      this.salePromotion.digitalOrigin = true;
      this.salePromotion.unifielDigifiel = true;
      this.salePromotion.traditionalOrigin = true;
    }
    //TRADICIONAL
    if(this.placement === 1){
      this.salePromotion.digitalOrigin = false;
      this.salePromotion.unifielDigifiel = false;
      this.salePromotion.traditionalOrigin = true;
    }
    //MEDIOS DIGITALES
    if(this.placement === 2){
      this.salePromotion.digitalOrigin = true;
      this.salePromotion.unifielDigifiel = true;
      this.salePromotion.traditionalOrigin = false;
    }
    //ORIGINACIÓN DIGITAL
    if(this.placement === 3){
      this.salePromotion.digitalOrigin = true;
      this.salePromotion.unifielDigifiel = false;
      this.salePromotion.traditionalOrigin = false;
    }
    //UNIFIEL
    if(this.placement === 4){
      this.salePromotion.digitalOrigin = false;
      this.salePromotion.unifielDigifiel = true;
      this.salePromotion.traditionalOrigin = false;
    }
  };

  // INFO
  getOrigin=(digitalOrigin:boolean, unifielDigifiel:boolean, traditionalOrigin:boolean)=>{
    let origin:string;
    if(digitalOrigin && unifielDigifiel && traditionalOrigin){
      origin = "[TODOS]";
    }
    if(!digitalOrigin && !unifielDigifiel && traditionalOrigin){
      origin = "[TRADICIONAL]";
    }
    if(digitalOrigin && unifielDigifiel && !traditionalOrigin){
      origin = "[MEDIOS DIGITALES]";
    }
    if(digitalOrigin && !unifielDigifiel && !traditionalOrigin){
      origin = "[ORIGINACIÓN DIGITAL]";
    }
    if(!digitalOrigin && unifielDigifiel && !traditionalOrigin){
      origin = "[UNIFIEL/DIGIFIEL]";
    }
    return origin;
  }
  getCatalogs=(commissionSaleId:number)=> {
    this.viewStatus=0;
    forkJoin(
      this.catEmployeeJobService.catalog(), //Puestos
      this.hypermatrixCatalogService.getCatalog('BusinessProductType'),  //Línea de Negocio
      this.commissionSalePromotionsService.getListCatRegions()  //Regiones
    )
    .pipe(
      tap(([catEmpJobResp,bpResp,catRegionsResp]:[any, any, any])=> {
        if(catEmpJobResp && bpResp && catRegionsResp) {

          this.employeeJobCatalog=catEmpJobResp.data.filter(e=> e.id<3);

          this.businessProductCatalog=bpResp.data.filter(e=> e.idCatalogType!=3).map(function(row) {
            return { id : row.idCatalogType, description : row.description }
          });

          this.regionsCatalog = catRegionsResp.data.map(function(row){
            return { _id : row.goalRegionId, _name : row.regionDescription }
          });

          if(this.mode==="edit" || this.mode==="detail"){
            this.getSalePromotionCatalogs(commissionSaleId);
          }else{
            this.viewStatus=1;
          }

        }
        else throwError;
      }),
      catchError(error=> {
        //console.log(error);
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al leer los catálogos.'));
      })
    )
    .subscribe();
  }
  getSalePromotionCatalogs=(commissionSaleId:number)=> {
    forkJoin(
      this.commissionSalePromotionsService.getListEmployeeJobs(commissionSaleId),
      this.commissionSalePromotionsService.getListBusinessProducts(commissionSaleId),
      this.commissionSalePromotionsService.getListFinancingTypes(commissionSaleId),
      this.commissionSalePromotionsService.getListPaymentTerms(commissionSaleId),
      this.commissionSalePromotionsService.getListAfiliates(commissionSaleId),
      this.commissionSalePromotionsService.getListFinancing(commissionSaleId),
      this.commissionSalePromotionsService.getListRegions(commissionSaleId),
      this.commissionSalePromotionsService.getListStates(commissionSaleId)
    )
    .pipe(
      tap(([employeeJobResp,businessProductResp,financingTypeResp,paymentTermResp,afiliateResp,financingResp,regionResp,stateResp]:[any, any, any, any, any, any, any, any])=> {
        if(employeeJobResp && businessProductResp && financingTypeResp && paymentTermResp && afiliateResp && financingResp && regionResp && stateResp) {

          //Cargar PUESTOS SELECCIONADOS
          this.selectedEmployeeJobs=employeeJobResp.data;
          this.selectedEmployeeJobsDD=employeeJobResp.data.map(function(row){
            return parseInt(row.id);
          });

          //Cargar LINEAS DE NEGOCIO SELECCIONADAS
          this.selectedBusinessProducts=businessProductResp.data;
          this.selectedBusinessProductsDD=businessProductResp.data.map(function(row){
            return parseInt(row.id);
          });

          //Cargar PRODUCTOS SELECCIONADOS
          this.selectedProducts = financingTypeResp.data.map(function(row){
            return { _id : row.id, _name : row.description }
          });

          //Cargar CONVENIOS SELECCIONADOS
          afiliateResp.data.forEach(function(row){
            this.selectedAfiliates.push({ _id : row.id, _name : row.description });
          },this);


          //Cargar REGIONES SELECCIONADAS
          this.selectedRegions = regionResp.data.map(function(row){
            return { _id : row.id, _name : row.description }
          });

          //Cargar ESTADOS SELECCIONADOS
          this.selectedStates = stateResp.data.map(function(row){
            return { _id : row.id, _name : row.description }
          });

          //Cargar CATALOGO DE PRODUCTOS
          let businessProductId:number[]=[];
          this.selectedBusinessProductsDD.forEach((el)=>{
            businessProductId.push(parseInt(el));
          });
          this.loadProducts(businessProductId);


          //Cargar CATALOGO DE CONVENIOS
          let financingTypeId:number[]=[];
          this.selectedProducts.forEach((el)=>{
            financingTypeId.push(el._id);
          });
          this.loadAfiliates(financingTypeId);

          //Cargar CATALOGO DE PLAZOS
          let afiliateId:number[]=[];
          this.selectedAfiliates.forEach((el)=>{
            afiliateId.push(el._id);
          });
          this.loadPaymentTerms(afiliateId, paymentTermResp);

          //Cargar PLAZOS SELECCIONADOS
          this.selectedPaymentTerms = paymentTermResp.data.map(function(row){
            return { _id : row.id, _name : row.description }
          });


          //Cargar PROMOCIONES SELECCIONADAS
          // this.selectedPromos = financingResp.data.map(function(row){
          //   return { _id : row.description === '«TODOS»' ? 'ALL' : row.description, _name : row.description }
          // });

          console.log(">>> this.selectedPaymentTerms=", this.selectedPaymentTerms);
          this.loadPromotions(financingResp);

          //Cargar CATALOGO DE ESTADOS
          let regions:number[]=[];
          this.selectedRegions.forEach((el)=>{
            if(el._id > 0) regions.push(el._id);
          });

          this.loadStates(regions);
          this.viewStatus=1;
        }
        else throwError;
      }),
      catchError(error=> {
        //console.log(error);
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al leer los catálogos.'));
      })
    )
    .subscribe();
  }
  loadProducts=(businessProductId:number[])=> {
    this.loadingProducts = 1;
    if(businessProductId != null && businessProductId.length > 0){
      this.vwCommissionConfiguratorService.getFinancingTypesByBusinessProduct(businessProductId)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          this.productCatalog = resp.data.map(function(row) {
            return { _id : row.id, _name : row.description }
          });
          this.loadingProducts = 0;
        }
      });
    }
  }
  loadAfiliates=(financingTypeId:number[])=>{
    this.loadingAfiliates = 1;
    if(financingTypeId != null && financingTypeId.length > 0){
      this.vwCommissionConfiguratorService.getAfiliatesByFinancingType(financingTypeId)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          this.afiliateCatalog=resp.data.map(function(row) {
            return { _id : row.id, _name : row.description }
          });
          this.loadingAfiliates = 0;
        }
      });
    }
  }
  loadPaymentTerms=(afiliateId:number[], paymentTermResp:any)=>{
    this.loadingPaymentTerms = 1;
    if(afiliateId != null && afiliateId.length > 0){
      this.vwCommissionConfiguratorService.getPaymentTermsByAfiliate(afiliateId)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          this.paymentTermCatalog=resp.data.map(function(row) {
            return { _id : row.id, _name : row.description }
          });
          console.log(">>> this.paymentTermCatalog=", this.paymentTermCatalog);
          if(paymentTermResp != null && this.selectedPaymentTerms.length === 0){
            //Cargar PLAZOS SELECCIONADOS
            this.selectedPaymentTerms = paymentTermResp.data.map(function(row){
              return { _id : row.id, _name : row.description }
            });
          }
          this.loadingPaymentTerms = 0;
        }
      });
    }
  }
  loadStates=(regions:number[])=>{
    this.loadingStates = 1;
    if(regions != null && regions.length > 0){
      this.commissionSalePromotionsService.getListCatStatesByRegion(regions)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          this.statesCatalog = resp.data.map(function(row){
            return { _id : row.stateGoalId, _name : row.stateDescription }
          });
          this.loadingStates = 0;
        }
      });
    }
  }
  loadPromotions=(financingResp:any)=> {
    this.loadingPromotions = 1;
    //console.log(">> this.selectedPromos=", this.selectedPromos);
    let params = {
      listBusinessProducts:this.selectedBusinessProducts.map(t=>t.id),
      listAnchorTypes:[1,2],
      listFinancingTypes:this.selectedProducts.map(t=>t._id),
      listAfiliates:this.selectedAfiliates.map(t=>t._id),
      listPayments:this.selectedPaymentTerms.map(t=>t._id)
    }
    //console.log(">>> loadPromotions >> params= ");
    //console.log(params);
    forkJoin(
      this.vwCommissionConfiguratorService.getFinancingByAfiliatePayment(params)
    )
    .pipe(
      tap((resp:any)=> {
        if(resp && resp[0].codeHttpStatus===200) {
          this.promoCatalog=resp[0].data.map(function(row) {
            return { _id : row.description === '«TODOS»' ? 'ALL' : row.description, _name : row.description }
          });
          this.promoCatalog = this.promoCatalog.sort(this.utils.sortBy('_name'));
          //console.log(">> this.promoCatalog=", this.promoCatalog);
          if(financingResp != null){
            this.selectedPromos = financingResp.data.map(function(row){
              return { _id : row.description === '«TODOS»' ? 'ALL' : row.description, _name : row.description }
            });
          }
          this.loadingPromotions = 0;
        }
        else if(resp && resp[0].codeHttpStatus===404) {
          this.toastr.info(resp[0].messageError);
          this.promoCatalog=[];
        }
        else throwError;
      }),
      catchError(error=> {
        //console.log(error);
        this.promoCatalog=[];
        return of(this.toastr.error('Ocurrió un error al leer promociones.'))
      })
    )
    .subscribe();
  }

}
